import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { zodResolver } from '@hookform/resolvers/zod';

import { AppContext, FormProps } from '../../interfaces';
import { RootState } from '../../store/store';
import { validationSchema } from '../Validation';

import Actions from './Actions';
import Content from './Content';
import Name from './Name';
import { Wrapper } from '../indexStyled';

interface Props {
    context: AppContext;
}

export const DEFAULT_FORM_VALUES: FormProps = {
    name: '',
    content: '',
};

const BannerForm: React.FC<Props> = ({ context }) => {
    const { activeBannerKey, editData, isLoading } = useSelector((state: RootState) => state.incidentBanners);

    const defaultValues = { ...DEFAULT_FORM_VALUES };
    const resolver = zodResolver(validationSchema());
    const methods = useForm<FormProps>({ defaultValues, resolver });

    useEffect(() => {
        if (activeBannerKey && editData) {
            methods.reset({ name: editData.name, content: editData.content });
        }
    }, [activeBannerKey]);

    return (
        <FormProvider {...methods}>
			<Wrapper>
				<Actions context={context} />
				<Name />
				<Content />
			</Wrapper>
        </FormProvider>
    );
};

export default BannerForm;
